// Copyright (c) Ergoss Logiciels - All rights reserved - Proprietary and confidential
export const environment = {
  nativeAuthProfile: 'pwicn',
  production: true,
  apiUrl: 'https://sarruiapi.chinacloudsites.cn/api/',
  legacyApiUrl: 'https://sarruiapi.chinacloudsites.cn/api/',
  authUrl: 'https://auth.sarrui.com.cn/connect/authorize',
  accessTokenUrl: 'https://auth.sarrui.com.cn/connect/token',
  logoutUrl: 'https://auth.sarrui.com.cn/home/logout',
  staticUrl: 'https://static.ergoss.cloud',
};
